import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { LookupOption } from '../../shared/models/lookup-option';
import { unwrapPagedList } from './paged-list';

@Injectable({ providedIn: 'root' })
export class ReferenceDataService {
  constructor(private readonly http: HttpClient) {}

  customers() { return this.query('/Breeze/Query/Customer?$filter=(Active%20eq%20true)&$top=50&v=1'); }
  warehouses() { return this.query('/Breeze/Query/Warehouse?$filter=Active%20eq%20true&v=1'); }
  terminalOperators() { return this.query('/Breeze/Query/TerminalOperator?$filter=Active%20eq%20true&v=10'); }
  transportTypes() { return this.query('/Breeze/Query/TransportType?$filter=(Active%20eq%20true)&v=1'); }
  parkingCargoDescriptions() { return this.query('/Breeze/Query/ParkingCargoDescription?$filter=Active%20eq%20true&v=1'); }
  organizationUnits() { return this.query('/Breeze/Query/OrganizationUnit?$filter=(Active%20eq%20true)&v=1'); }
  berths() { return this.query('/Breeze/Query/Berth?$filter=(Active%20eq%20true)&v=1'); }
  shifts() { return this.query('/Breeze/Query/Shift?$filter=(Active%20eq%20true)&$top=50&v=1'); }
  permitUserBadges() {
    return this.query("/Breeze/Query/PermitUserBadge?$filter=(Active%20eq%20true)%20and%20(Name%20ne%20null)%20and%20(Code%20ne%20null)%20and%20(Badge%20ne%20null)&$top=50&v=1");
  }
  truckModuleVehicles(terminalOperatorCode?: string) {
    const filter = terminalOperatorCode
      ? `(Active eq true) and (LastKnownTerminalOperatorCode eq '${terminalOperatorCode}')`
      : '(Active eq true)';
    return this.query(`/Breeze/Query/TruckModuleVehicle?$filter=${encodeURIComponent(filter)}&$top=200&v=1`);
  }

  private query(path: string) {
    return this.http.get<unknown>(`${API_BASE_URL}${path}`).pipe(map(raw => unwrapPagedList<LookupOption>(raw)));
  }
}
